<script>
  import { layoutMethods } from "@/Template/State/Helpers";

  /**
   * Nav-bar Component
   */
  export default {
    data() {
      return {
        text: null,
        flag: null,
        value: null,
        myVar: 1,
      };
    },
    methods: {
      ...layoutMethods,
      toggleHamburgerMenu() {
        var windowSize = document.documentElement.clientWidth;
        let layoutType = document.documentElement.getAttribute("data-layout");

        document.documentElement.setAttribute("data-sidebar-visibility", "show");
        let visiblilityType = document.documentElement.getAttribute("data-sidebar-visibility");

        if (windowSize > 767)
          document.querySelector(".hamburger-icon").classList.toggle("open");

        //For collapse horizontal menu
        if (
          document.documentElement.getAttribute("data-layout") === "horizontal"
        ) {
          document.body.classList.contains("menu") ?
            document.body.classList.remove("menu") :
            document.body.classList.add("menu");
        }

        //For collapse vertical menu

        if (visiblilityType === "show" && (layoutType === "vertical" || layoutType === "semibox")) {
          if (windowSize < 1025 && windowSize > 767) {
            document.body.classList.remove("vertical-sidebar-enable");
            document.documentElement.getAttribute("data-sidebar-size") == "sm" ?
              document.documentElement.setAttribute("data-sidebar-size", "") :
              document.documentElement.setAttribute("data-sidebar-size", "sm");
          } else if (windowSize > 1025) {
            document.body.classList.remove("vertical-sidebar-enable");
            document.documentElement.getAttribute("data-sidebar-size") == "lg" ?
              document.documentElement.setAttribute("data-sidebar-size", "sm") :
              document.documentElement.setAttribute("data-sidebar-size", "lg");
          } else if (windowSize <= 767) {
            document.body.classList.add("vertical-sidebar-enable");
            document.documentElement.setAttribute("data-sidebar-size", "lg");
          }
        }

        //Two column menu
        if (document.documentElement.getAttribute("data-layout") == "twocolumn") {
          document.body.classList.contains("twocolumn-panel") ?
            document.body.classList.remove("twocolumn-panel") :
            document.body.classList.add("twocolumn-panel");
        }
      },
      async logout() {
        var vm = this;

        try {
          vm.$loading.on('nav_btn_logout');
          var resp = await vm.$api.Auth.logout();
          if (!resp.data.is_error) {
            vm.$api.unsetApiToken();

            vm.$router.replace({ name: 'login' });

            vm.$flash.success(resp.data.message);
          }
        } catch (error) {
          vm.$flash.error(error.response.data.message);
        }

        vm.$loading.off('nav_btn_logout');
      }
    },
    mounted() {
      document.addEventListener("scroll", function () {
        var pageTopbar = document.getElementById("page-topbar");
        if (pageTopbar) {
          document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50 ? pageTopbar.classList.add(
            "topbar-shadow") : pageTopbar.classList.remove("topbar-shadow");
        }
      });
      if (document.getElementById("topnav-hamburger-icon"))
        document
          .getElementById("topnav-hamburger-icon")
          .addEventListener("click", this.toggleHamburgerMenu);
    },
  };
</script>

<template>
  <header id="page-topbar">
    <div class="layout-width">
      <div class="navbar-header">
        <div class="d-flex">
          <!-- LOGO -->
          <div class="navbar-brand-box horizontal-logo">
            <router-link to="/" class="logo logo-dark">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-dark.png" alt="" height="17" />
              </span>
            </router-link>

            <router-link to="/" class="logo logo-light">
              <span class="logo-sm">
                <img src="@/assets/images/logo-sm.png" alt="" height="22" />
              </span>
              <span class="logo-lg">
                <img src="@/assets/images/logo-light.png" alt="" height="17" />
              </span>
            </router-link>
          </div>

          <button type="button" class="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none"
            id="topnav-hamburger-icon">
            <span class="hamburger-icon">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        <div class="d-flex align-items-center">
          <BDropdown variant="link" class="ms-sm-3 header-item topbar-user" :auto-close="false"
            toggle-class="rounded-circle arrow-none  shadow-none" menu-class="dropdown-menu-end"
            :offset="{ alignmentAxis: -14, crossAxis: 0, mainAxis: 0 }">
            <template #button-content>
              <span class="d-flex align-items-center">
                <div class="avatar-title rounded text-dark bg-light">
                  <i class="mdi mdi-account-circle-outline fs-1"></i>
                </div>
                <span class="text-start ms-xl-2">
                  <span class="d-none d-xl-inline-block ms-1 fw-medium user-name-text">{{ $ac.user().name }}</span>
                  <span class="d-none d-xl-block ms-1 fs-12 user-name-sub-text">{{ $ac.user().ref_no }}</span>
                </span>
              </span>
            </template>
            <router-link class="dropdown-item" :to="{ name: 'profile' }" v-if="$ac.hasAccess('profile_read')"><i
                class="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span class="align-middle"> {{ $t('basic.btn.profile') }}</span>
            </router-link>
            <router-link to="" class="dropdown-item d-flex align-items-center"
              @click.prevent="!$loading.get('nav_btn_logout') && logout()">
              <loading :loading="$loading.get('nav_btn_logout')" variant="dark" type="button">
                <i class="mdi mdi-logout text-muted me-2 fs-16"></i>
              </loading>
              <span data-key="t-logout"> {{ $t('basic.btn.logout') }}</span>
            </router-link>
          </BDropdown>
        </div>
      </div>
    </div>
  </header>
</template>

<style lang="scss">
  .navbar-header {
    padding: 0;
  }
</style>